export default __webpack_public_path__ + "static/media/logo-header.6ea035c4.svg";